// extracted by mini-css-extract-plugin
export var card = "_lz-5";
export var cardSelected = "_lz-4";
export var image = "_lz-3";
export var modal = "_lz-0";
export var modalContent = "_lz-1";
export var table = "_lz-2";